import React, { ChangeEvent } from "react";
import {
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { FastField, useField, useFormikContext } from "formik";

export type Option = { [key: string]: string } | string;

interface MultipleSelect {
  fieldname: string;
  label: string;
  options: Option[];
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  displayErr?: boolean;
  multiple?: boolean;
  value?: any;
}

const MultipleSelect = (props: MultipleSelect) => {
  const { label, fieldname, options, disabled, displayErr } = props;
  useFormikContext();
  const [field, meta] = useField(fieldname);
  const { setFieldTouched, values } = useFormikContext();

  const handleBlur = (event: ChangeEvent<HTMLInputElement>) => {
    console.log("touched", field.name);
    setFieldTouched(field.name, true);
  };
  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel disabled={disabled} id={fieldname}>
        {label}
      </InputLabel>
      <FastField
        as={Select}
        multiple={true}
        name={fieldname}
        onTouch={handleBlur}
        disabled={disabled}
        labelId={fieldname}
        variant="outlined"
        renderValue={(selected: string[]) =>
          (selected as string[]).filter((i) => options.includes(i)).join(", ")
        }
        {...props}
      >
        {options &&
          options.length &&
          options.map((option: Option, idx: number) => {
            if (typeof option === "string") {
              return (
                <MenuItem key={idx} value={option} disabled={disabled}>
                  <Checkbox checked={field.value.includes(option)} />
                  <ListItemText primary={option} />
                  {/*{option}*/}
                </MenuItem>
              );
            }
          })}
      </FastField>
      <FormHelperText error>
        {displayErr && meta.error ? meta.error : ""}
      </FormHelperText>
    </FormControl>
  );
};

export default MultipleSelect;
